import {Covid19I18n} from '@/locales/base.message.locales';

export const covid_19: Covid19I18n = {
  help_people: 'Ajude as pessoas',
  hold_hands: 'De mãos dadas novamente',
  printer_3d: 'Use sua impressora 3d',
  produce_masks: 'Produzir máscaras',
  send_hospitals: 'Enviar para hospitais',
  description: `<p>Nunca foi tão necessário utilizar a inteligência coletiva como agora na resposta á  pandemia do coronavirus. 
<br><br>
Junte-se a nós nos desafios de proteção dos profissionais de saúde, assistência social a comunidades carentes e integridade da cadeia de abastecimento e logística.</p>`
};
